import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";

export default class PageMobileUsersList extends PageList {
    constructor() {
        super();
    }

    init($data) {
        super.init($data);

        $(".jsBtnExcel").on("click", this.onCreateExcel.bind(this))

    }

    initList() {
        // h
        let h = this.getAvailableHeight();
        //
        this.theGrid = new GridWrapper($(".jsList"));

        let options = {
            dataSource:
            {
                events: {
                },
                remote: {
                    read: {
                        url: "/api/users/mobileusergridlist?api_key=" + TheApp.CurrentContext.app.jsApiKey,
                        dataType: "json",
                        operations: ["sort", "skip", "take", "filter"],
                    }
                },
                schema:
                {
                    data: "Items",
                    total: function (result) {
                        return result["count"];
                    }
                }
            },
            sorting: {
                multiple: false,
                allowUnsort: true
            },
            paging: {
                pageSize: 12,
                pageLinksCount: 10
            },
            rowHover: false,
            altRows: false,
            selection: {
                type: "row",
                multiple: false,
                toggle: true,
            },
            columns: [
                {
                    field: "ContractIdOrCustomerId",
                    title: "ContractID/CustomerID",
                    sortable: false
                },
                {
                    field: "UserID",
                    title: "DriverID/FleetManagerID",
                    sortable: false
                },
                {
                    field: "UserName",
                    title: "Cognome Nome",
                    sortable: false
                },
                {
                    field: "UserTypeLabel",
                    title: "Tipo",
                    sortable: false
                },
                //{
                //	field: "StartDate",
                //	title: "StartDate"
                //},
                //{
                //	field: "EndDate",
                //	title: "EndDate"
                //},
                //{
                //	field: "RecordDtInsert",
                //	title: "Data Importazione",
                //	sortable: false
                //},
                {
                    field: "StatusLabel",
                    title: "Stato Utente",
                    sortable: false
                },
                {
                    field: "Email",
                    title: "Email",
                    sortable: false,
                    width: "300px"
                },
                //{
                //	field: "Roles",
                //	title: "Ruoli"
                //},
                {
                    field: "TrixRecordDtInsert",
                    title: "Data Creazione",
                    sortable: false
                },
                {
                    field: "TrixStatusLabel",
                    title: "Stato Utente Mobile",
                    sortable: false
                },
                {
                    title: "ACTION",
                    width: "150px",
                    // field: "_idx",
                    columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
                }
            ],
            events: {

            },
            scrolling: true,
            resizing: true,
            height: h + "px"
        }

        this.theGrid.create(options, this.data.rows);
        this.theGrid.enableSearch($(".jsListSearch"), {
            or: [
                { path: "UserID", filter: "contains", value: "" },
                { path: "UserName", filter: "contains", value: "" },
                { path: "UserTypeLabel", filter: "contains", value: "" },
                { path: "StatusLabel", filter: "contains", value: "" },
                { path: "Email", filter: "contains", value: "" },
                { path: "TrixStatusStatusLabel", filter: "contains", value: "" }
            ]
        }, false);
        this.theGrid.init("jsList");
        //
        $(".jsBtnSearch").on("click", this.onClickSearch.bind(this, false));
        $(".jsListSearch").on("keyup", this.onClickSearch.bind(this, true));
        // var a = StateManager.getViewState("jsList")
        jQuery(window).on("resize.grid", this.onResize.bind(this));

        return;
    }

    initListButton(ev) {
        // eventType, gridWrp, dataIndex, dataRow, mcCol
        // alert(this.data.tableSUid + ev.dataRow.Value);
        try {
            if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_DELETE))) {
                $(".btnReset", ev.mcCol).on("click", this.onReset.bind(this, ev.dataIndex));
                if (ev.dataRow.TrixStatus !== null) {
                    $(".btnView", ev.mcCol).on("click", this.onNavigate.bind(this, ev.dataIndex));
                } else {
                    $(".btnView", ev.mcCol).remove();
                }
                if (ev.dataRow.TrixStatus !== null && ev.dataRow.TrixStatus == 1) {
                    $(".btnEmailConfirm", ev.mcCol).on("click", this.onConfirmEmail.bind(this, ev.dataIndex));
                } else {
                    $(".btnEmailConfirm", ev.mcCol).remove();
                }
            } else if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_READ))) {
                $(".btnReset", ev.mcCol).remove();
                if (ev.dataRow.TrixStatus !== null) {
                    $(".btnView", ev.mcCol).on("click", this.onNavigate.bind(this, ev.dataIndex));
                } else {
                    $(".btnView", ev.mcCol).remove();
                }
            } else {
                $(".btnReset", ev.mcCol).remove();
                $(".btnView", ev.mcCol).remove();
                $(".btnEmailConfirm", ev.mcCol).remove();
            }
        } catch (e) {

        }

    }

    onClickSearch(onKyeUp, event) {
        if (onKyeUp == true) {
            if (event.keyCode != 13)
                return;
            event.preventDefault();
        }
        this.theGrid._onGridSearchEvent(true);
    }

    getAvailableHeight() {
        let a = jQuery(".js-size");
        let i = 0;
        for (let x = 0; x < a.length; x++) {
            i += jQuery(a[x]).outerHeight();
        }
        i += 50; // padding app container
        i += 78; // search box
        i += 143; // paging
        let h = jQuery(window).height() - i;
        return h;
    }

    onResize(e) {
        //debugger;
        this.theGrid.setHeight(this.getAvailableHeight());
    }

    onReset(dataIndex) {
        let modal = new ModalConfirm($("#template-modalConfirm"));
        let email = this.theGrid.data[dataIndex].Email
        modal.create(
            {
                title: "Conferma reset",
                body: "Sei sicuro di voler resettare l'utente " + email + "? Non puoi annullare questa azione.",
                yes: "SI",
                no: "NO",
                danger: true // viene il pulsante rosso, altrimenti blue
            }, this.onConfirmReset.bind(this, dataIndex));
        modal.init();
    }

    onConfirmReset(dataIndex, bConfirm) {
        if (bConfirm) {
            // this.theGrid.deleteByDataIndex(dataIndex)
            this.showPreloader(true);
            let rq = {
                Value: this.theGrid.data[dataIndex].TrixUserUid
            }
            thatServiceManeger.standardCall(this.data.serviceDeleteRoute + this.data.tableUid, rq, this.onResetServiceHandler.bind(this, dataIndex));
        }
    }

    onResetServiceHandler(dataIndex, rs) {
        this.showPreloader(false);
        //
        if (rs.Success) {
            /*		this.theGrid.deleteByDataIndex(dataIndex);*/
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "SUCCESSO",
                    body: "Reset eseguito correttamente!",
                    close: "CHIUDI",
                    error: false
                });
            modal.init();
            setTimeout(window.location.reload(true), 60000);
        } else {
            let error = null;
            if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
                error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
                if (rs.Errors[0].RefsUid.length > 0) {
                    error = error.replace("{0}", rs.Errors[0].RefsUid);
                }
            }
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "Si è verificato un'errore",
                    body: error,
                    close: "CHIUDI",
                    error: true
                });
            modal.init();
        }
        //this.showPreloader(false);
    }

    onConfirmEmail(dataIndex) {
        let modal = new ModalConfirm($("#template-modalConfirm"));
        let email = this.theGrid.data[dataIndex].Email
        modal.create(
            {
                title: "Conferma Email",
                body: "Sei sicuro di voler confermare l'email dell'utente " + email + "?",
                yes: "SI",
                no: "NO",
                danger: true // viene il pulsante rosso, altrimenti blue
            }, this.onConfirmEmailDo.bind(this, dataIndex));
        modal.init();
    }

    onConfirmEmailDo(dataIndex, bConfirm) {
        if (bConfirm) {
            // this.theGrid.deleteByDataIndex(dataIndex)
            this.showPreloader(true);
            let rq = {
                Value: this.theGrid.data[dataIndex].TrixUserUid
            }
            thatServiceManeger.standardCall(this.data.serviceEmailConfirmRoute + this.data.tableUid, rq, this.onConfirmEmailServiceHandler.bind(this, dataIndex));
        }
    }

    onConfirmEmailServiceHandler(dataIndex, rs) {
        this.showPreloader(false);
        //
        if (rs.Success) {
            /*		this.theGrid.deleteByDataIndex(dataIndex);*/
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "SUCCESSO",
                    body: "Conferma email eseguita correttamente!",
                    close: "CHIUDI",
                    error: false
                });
            modal.init();
            setTimeout(window.location.reload(true), 60000);
        } else {
            let error = null;
            if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
                error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
                if (rs.Errors[0].RefsUid.length > 0) {
                    error = error.replace("{0}", rs.Errors[0].RefsUid);
                }
            }
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "Si è verificato un'errore",
                    body: error,
                    close: "CHIUDI",
                    error: true
                });
            modal.init();
        }
        //this.showPreloader(false);
    }

    onCreateExcel() {
        let s = $.trim($(".jsListSearch").val())

        window.open(TheApp.Env.BaseUrlNls + "mobileusers/excel?search=" + Base64.toBase64(s, true), "_blank");
    }

    onNavigate(dataIndex) {
        document.location.href = TheApp.Env.BaseUrlNls + "mobileusers/detail/" + Base64.toBase64(this.theGrid.data[dataIndex].TrixUserUid, true) + "?__pi=" + this.data.page.PageId;
    }

}

